import React, { useState } from 'react'
import "../css/jpOutlet.css"
import JPPositionBread from '../../../../page-module/page-services/job-position/ts/jp_Breadcrumb'
import JPSidebar from '../../../../page-module/page-services/job-position/ts/jp_Sidebar'
import { Outlet } from 'react-router-dom'
import { menuNavData } from '../../../../page-module/page-services/job-position/ts/mockData'

export type JobFilters = Record<string, Set<string>>

const JPOulet = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [filters, setFilters] = useState<JobFilters>(() => {
    return menuNavData.reduce((acc, menu) => {
      acc[menu.field] = new Set()
      return acc
    }, {} as JobFilters)
  })

  
  return (
    <div className='scl--jp-con-out-st'>
        <div className='scl--jppb-con-st'>
            <JPPositionBread onToggleSidebar={() => setIsSidebarOpen(v => !v)}/>
        </div>

        <div className={`scl--jps-con-st ${isSidebarOpen ? 'active' : ''}`}>
          <JPSidebar
            filters={filters}
            onChangeFilters={setFilters}
          />
        </div>

        <div className='scl--jpo-con-st'>
            <Outlet context={{ filters }} />
        </div>
    </div>
  )
}

export default JPOulet